import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IComboboxOption } from '../combobox-field/combobox-field.component';
import { IFieldSpecs } from '../interfaces/field-specs';
import { MultiComboboxComponent } from '../multi-combobox/multi-combobox.component';

/**
 * Number-field
 * Generate a simple text field
 * @deprecated use MultiComboboxComponent instead
 */
@Component({
    selector: 'multiselect-field',
    template: `
    <multi-combobox #multiComboboxElement
        [fieldConfig]="multiComboboxFieldConfig"
        [items]="options"></multi-combobox>
    `
})
export class MultiSelectFieldComponent implements OnChanges {
    @Input()
    public label: string;
    @Input()
    public placeholder: string;
    @Input()
    public group: FormGroup;
    @Input()
    public controlName: string;
    @Input()
    public options: IComboboxOption[];

    @ViewChild('multiComboboxElement')
    public multiComboboxElement: MultiComboboxComponent;

    public multiComboboxFieldConfig: IFieldSpecs;

    public ngOnChanges(): void {
        this.convertInputToMultiComboboxExpectations();
    }

    private convertInputToMultiComboboxExpectations(): void {
        this.multiComboboxFieldConfig = {
            formControlName: this.controlName,
            formGroup: this.group,
            label: this.label
        };
        if(this.placeholder){
            this.multiComboboxFieldConfig.placeholder = this.placeholder;
        }
    }

}
